import { Box, Button } from "grommet";

export function Footer({ signOut }: any): React.ReactElement {
  return (
    <Box gridArea="sign-out">
      <Button label="SIGN OUT" fill={true} onClick={signOut} />
    </Box>
  );
}
